var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRightArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09443 11.6198C1.83298 11.8869 1.40309 11.8869 1.14164 11.6198L0.94808 11.4221C0.69439 11.1629 0.69439 10.7485 0.94808 10.4894L5.23859 6.10647L0.94808 1.72357C0.69439 1.46442 0.69439 1.05001 0.94808 0.790856L1.14164 0.593132C1.40309 0.326052 1.83298 0.326052 2.09443 0.593132L7.03503 5.64012C7.28872 5.89927 7.28872 6.31368 7.03503 6.57283L2.09443 11.6198Z",
    fill: "#0C002C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.91578 0.768016C1.75238 0.601091 1.48369 0.601091 1.32029 0.768016L1.12673 0.965739C0.968173 1.12771 0.968173 1.38671 1.12673 1.54869L5.58844 6.10647L1.12673 10.6643C0.968174 10.8262 0.968174 11.0852 1.12673 11.2472L1.32029 11.4449C1.48369 11.6119 1.75238 11.6119 1.91578 11.4449L6.85638 6.39795C7.01494 6.23598 7.01494 5.97697 6.85638 5.815L1.91578 0.768016ZM0.962986 0.418249C1.32248 0.0510134 1.91359 0.0510135 2.27308 0.418249L7.21368 5.46523C7.5625 5.82157 7.5625 6.39138 7.21368 6.74771L2.27308 11.7947C1.91359 12.1619 1.32248 12.1619 0.962986 11.7947L0.769431 11.597C0.420606 11.2406 0.420607 10.6708 0.769431 10.3145L4.88875 6.10647L0.769431 1.89845C0.420606 1.54212 0.420606 0.972308 0.769431 0.615972L0.962986 0.418249Z",
    fill: "#0C002C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightArrowBlack);
export default __webpack_public_path__ + "static/media/ico_right_arrow_black.9269071e301a3af38749a4533f1cbc21.svg";
export { ForwardRef as ReactComponent };